import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DocumentTitle from 'src/components/DocumentTitle/DocumentTitle';
import Page from 'src/components/Page/Page';
import useDocumentTitle from 'src/hooks/use-document-title';
import { StaticIdentifiers } from 'src/constants/cluster-status';
import { Button, FaIcon, Select, SelectOptionProps } from '@innovationnorway/component-library';
import { useSearchParams } from 'react-router-dom';
import { icon } from '@fortawesome/fontawesome-svg-core';
import useDownloadGoalOverviewReport from 'src/features/siva/reporting/hooks/useDownloadGoalOverviewReport';
import saveAs from 'file-saver';

import useSivaYearList from 'src/hooks/use-year-list-reporting';

const pageSearchParams = {
  year: 'year',
  actorType: 'actorType',
};

const ExtractGoalAccomplishment: React.FC = () => {
  const { t: tCommon } = useTranslation();
  const { t: tPageTitles } = useTranslation('pageTitles');
  const { t: tSiva } = useTranslation('siva');
  const { documentTitle } = useDocumentTitle(tPageTitles('sivaReporting'));
  const [searchParams, setSearchParams] = useSearchParams();

  const actorType = searchParams.get(pageSearchParams.actorType) || StaticIdentifiers.SivaBusinessGarden;

  const [selectedYear, setSelectedYear] = useState<string | undefined>(undefined);
  const yearList = useSivaYearList(2023);

  const { fetchReport } = useDownloadGoalOverviewReport(
    actorType,
    selectedYear === '' ? undefined : parseInt(selectedYear || ''),
  );

  const yearOptions: SelectOptionProps[] = React.useMemo(() => {
    return [{ value: '', text: 'Alle år' }].concat(
      yearList.map((item) => ({ value: item.toString(), text: item.toString() })),
    );
  }, [yearList]);
  const handleDownloadReportOnClick = async () => {
    const file = await fetchReport.mutateAsync();
    saveAs(file.data, file.fileName);
  };

  return (
    <DocumentTitle title={documentTitle}>
      <Page>
        <h1>{tSiva('export.goalAccomplishment.header')}</h1>
        <div className="display--flex gap--3 align-items--center">
          <Select
            value={selectedYear}
            className="margin-0-on-all-children"
            label="Rapportår"
            name="year"
            hideError
            placeholder={tCommon('selectYear')}
            options={yearOptions}
            onChange={setSelectedYear}
          />
          <Select
            name={tCommon('type')}
            label={tCommon('type')}
            options={[
              {
                text: tCommon('businessGarden'),
                value: StaticIdentifiers.SivaBusinessGarden,
              },
              {
                text: tCommon('incubator'),
                value: StaticIdentifiers.SivaIncubator,
              },
            ]}
            value={actorType}
            onChange={(actorType) =>
              setSearchParams(
                (prevValue) => {
                  const year = prevValue.get(pageSearchParams.year) || '';
                  return { actorType, year };
                },
                { replace: true },
              )
            }
          />
          <Button onClick={handleDownloadReportOnClick} variant="link">
            <FaIcon
              className={'margin-right--1'}
              icon={icon({ prefix: 'fal', iconName: 'file-export' })}
              size="1x"
            />
            {`${tSiva('export.goalAccomplishment.exportButton')} ${
              actorType === StaticIdentifiers.SivaBusinessGarden
                ? tCommon('businessGarden').toLowerCase()
                : tCommon('incubator').toLowerCase()
            }`}
          </Button>
        </div>
      </Page>
    </DocumentTitle>
  );
};

export default ExtractGoalAccomplishment;
